export default "__VITE_ASSET__f2f4a91f__"